export default "__VITE_ASSET__BiBd3ECx__"